// const BASE_API_URL = "http://localhost:4000/api/";
// const BASE_API_URL = "http://localhost:5000/api/";
// const BASE_API_URL = "http://localhost:3001/api/";
const BASE_API_URL = "https://backendcherryk.cherrykmyanmar.com:4000/api/";

export default BASE_API_URL;
